import { __extends } from "tslib";
import { IgrAssigningSeriesStyleEventArgsBase } from "./igr-assigning-series-style-event-args-base";
/**
 * Represents event arguments class for the AssigningCategoryStyleEvent
*/
var IgrAssigningSeriesShapeStyleEventArgsBase = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrAssigningSeriesShapeStyleEventArgsBase, _super);
    function IgrAssigningSeriesShapeStyleEventArgsBase() {
        return _super.call(this) || this;
    }
    Object.defineProperty(IgrAssigningSeriesShapeStyleEventArgsBase.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrAssigningSeriesShapeStyleEventArgsBase.prototype, "strokeThickness", {
        /**
         * Gets or sets stroke thickness to use for the current item.
        */
        get: function () {
            return this.i.t;
        },
        set: function (v) {
            this.i.t = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrAssigningSeriesShapeStyleEventArgsBase.prototype, "radiusX", {
        /**
         * Gets or sets corner radius X to use for the current item, if applicable.
        */
        get: function () {
            return this.i.r;
        },
        set: function (v) {
            this.i.r = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrAssigningSeriesShapeStyleEventArgsBase.prototype, "radiusY", {
        /**
         * Gets or sets corner radius Y to use for the current item, if applicable.
        */
        get: function () {
            return this.i.s;
        },
        set: function (v) {
            this.i.s = +v;
        },
        enumerable: false,
        configurable: true
    });
    return IgrAssigningSeriesShapeStyleEventArgsBase;
}(IgrAssigningSeriesStyleEventArgsBase));
export { IgrAssigningSeriesShapeStyleEventArgsBase };
